// extracted by mini-css-extract-plugin
export default {"text-wrapper":"text-wrapper--+iMXo","textWrapper":"text-wrapper--+iMXo","text":"text--IaJ6W"};